import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';

import { AppState } from '../types/app-state.type';
import { FormLoadState, FormRootState } from './form-submission.type';

export type FormSubmissionBaseSelectors<Payload> = {
  formRoot: MemoizedSelector<AppState, FormRootState<Payload>>;
  formPayload: MemoizedSelector<AppState, Payload>;
  formSubmissionInProgress: MemoizedSelector<AppState, boolean>;
  formIsSubmitted: MemoizedSelector<AppState, boolean>;
  formSubmissionSucceeded: MemoizedSelector<AppState, boolean>;
  formSubmissionFailed: MemoizedSelector<AppState, boolean>;
};

export function getBaseSelectors<Payload>(
  featureKey: string,
): FormSubmissionBaseSelectors<Payload> {
  const formRoot: MemoizedSelector<
    AppState,
    FormRootState<Payload>
  > = createFeatureSelector(featureKey);

  const formPayload: MemoizedSelector<AppState, Payload> = createSelector(
    formRoot,
    state => state.requestPayload,
  );

  const formSubmissionInProgress: MemoizedSelector<AppState, boolean> =
    createSelector(
      formRoot,
      state => state.loadState === FormLoadState.Submitting,
    );

  const formIsSubmitted: MemoizedSelector<AppState, boolean> = createSelector(
    formRoot,
    state =>
      state.loadState !== FormLoadState.Idle &&
      state.loadState !== FormLoadState.Submitting,
  );

  const formSubmissionSucceeded: MemoizedSelector<AppState, boolean> =
    createSelector(
      formRoot,
      state => state.loadState === FormLoadState.Success,
    );

  const formSubmissionFailed: MemoizedSelector<AppState, boolean> =
    createSelector(
      formRoot,
      state => state.loadState === FormLoadState.Failure,
    );

  return {
    formRoot,
    formPayload,
    formSubmissionInProgress,
    formIsSubmitted,
    formSubmissionSucceeded,
    formSubmissionFailed,
  };
}
